import http from '../utilities/http-common'

const getStepsByType = (type) => {
    return http.get('/api/v1/ordersStep/' + type)
}

export default {
    getStepsByType
}
